/**
 * FAQ 서비스
 */

import apiClient from './api';
import {
  FAQ,
  FAQFilter,
  FAQListResponse,
} from '../types/faq';

export const faqService = {
  /**
   * FAQ 목록 조회
   */
  async getFAQs(filter: FAQFilter = {}): Promise<FAQListResponse> {
    const params = new URLSearchParams();
    
    if (filter.category) params.append('category', filter.category);
    if (filter.status) params.append('status', filter.status);
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: FAQListResponse }>(`/admin/faqs?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      faqs: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * FAQ 상세 조회
   */
  async getFAQ(id: number): Promise<FAQ> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { faq: FAQ } }>(`/admin/faqs/${id}`);
    // return response.data.data.faq;

    throw new Error('Not implemented');
  },

  /**
   * FAQ 등록
   */
  async createFAQ(data: Partial<FAQ>): Promise<FAQ> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { faq: FAQ } }>('/admin/faqs', data);
    // return response.data.data.faq;

    throw new Error('Not implemented');
  },

  /**
   * FAQ 수정
   */
  async updateFAQ(id: number, data: Partial<FAQ>): Promise<FAQ> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.put<{ data: { faq: FAQ } }>(`/admin/faqs/${id}`, data);
    // return response.data.data.faq;

    throw new Error('Not implemented');
  },

  /**
   * FAQ 삭제
   */
  async deleteFAQ(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.delete(`/admin/faqs/${id}`);

    throw new Error('Not implemented');
  },

  /**
   * FAQ 순서 변경
   */
  async updateDisplayOrder(id: number, displayOrder: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.put(`/admin/faqs/${id}/display-order`, { display_order: displayOrder });

    throw new Error('Not implemented');
  },
};

